import { render } from "./ItensNotasFiscais.vue?vue&type=template&id=22d9d1e8&scoped=true"
import script from "./ItensNotasFiscais.vue?vue&type=script&lang=js"
export * from "./ItensNotasFiscais.vue?vue&type=script&lang=js"

import "./ItensNotasFiscais.vue?vue&type=style&index=0&id=22d9d1e8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d9d1e8"]])

export default __exports__